<template>
  <section class="eva-page">
    <v-row>
      <v-col cols="12" offset="0" md="10" offset-md="1">

        <div class="eva-top">
          <v-breadcrumbs
            large
            :items="crumbs"
            divider="/"
            class="pl-0 eva-breadcrumbs"
          />

          <div class="eva-titlebar">
            <div class="eva-title">
              <v-icon color="primary" class="mr-2">
                mdi-book-plus
              </v-icon>
              <span class="primary--text">Criar Diário de Secção</span>
            </div>
          </div>
        </div>

        <v-card class="eva-card mt-6" elevation="10">
          <v-card-title class="eva-card__title primary white--text">
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="white">mdi-clipboard-plus</v-icon>
              <span class="font-weight-bold">
                Novo Diário de Secção
              </span>
            </div>
          </v-card-title>

          <v-card-text class="pt-6">
            <SectionDiary method="create" />
          </v-card-text>
        </v-card>

      </v-col>
    </v-row>
  </section>
</template> 
 
<script>
import SectionDiary from '@/components/SectionDiaries/SectionDiary'

export default {
  components: {
    SectionDiary
  },

  mounted() {
    if (!this.$store.getters.hasPermission(["super", "section_diaries.write", "section_diaries.manage"])) {
      this.$router.push('/admin')
    }
  },

  computed: {
    crumbs() {
      return [
        {
          text: 'Dashboard',
          disabled: false,
          to: '/admin',
          exact: true,
        },
        {
          text: 'Listagem de diários de secção',
          disabled: false,
          to: '/section-diaries',
          exact: true,
        },
        {
          text: 'Criar Diário de Secção',
          disabled: true,
          to: window.location.href,
          exact: true,
        },
      ]
    }
  }
}
</script>

<style scoped>
.eva-page {
  padding-bottom: 32px;
}

.eva-top {
  margin-top: 8px;
}

.eva-breadcrumbs :deep(.v-breadcrumbs__item) {
  font-size: 13px;
}

.eva-titlebar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
}

.eva-title {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.2px;
}

.eva-card {
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(0,0,0,0.06);
}

.eva-card__title {
  font-weight: 800;
  letter-spacing: 0.2px;
}
</style>